import { getDocumentCategoryText, getDocumentTypeText } from "../helpers/logHelpers";

// ============================================================================
// ユーザーステータス（item.user_status に対応）
// ============================================================================
export const USER_STATUS = {
  ACTIVE: { id: 0, name: "active", hex: "#19665cff", text: "有効" },
  LOCK_1: { id: 1, name: "lock",   hex: "#ff4d4fff", text: "ロック" },
  LOCK_2: { id: 2, name: "lock",   hex: "#ff4d4fff", text: "ロック" },
};

// ============================================================================
// 操作内容一覧（ログの log_timing に対応）
// ============================================================================
export const OPERATION_DETAIL = {
  LOGIN:         { id: 1, name: "login",          hex: "#19665cff", text: "ログイン" },
  LOGOUT:        { id: 2, name: "logout",         hex: "#19665cff", text: "ログアウト" },
  REGIST:        { id: 3, name: "regist",         hex: "#19665cff", text: "登録" },
  SEARCH_DETAIL: { id: 4, name: "search_detail",  hex: "#19665cff", text: "詳細検索" },
  EDIT:          { id: 5, name: "edit",           hex: "#19665cff", text: "編集" },
  SEARCH_TITLE:  { id: 6, name: "search_title",   hex: "#19665cff", text: "タイトル検索" },
  AUTO_NUMBER:   { id: 7, name: "auto_number",    hex: "#19665cff", text: "オートナンバー発行" },
};

// ============================================================================
// ログイン状態一覧（log_status に対応）
// ============================================================================
export const LOGIN_STATUS = {
  SUCCESS:       { id: 1, hex: "#19665cff", text: "成功" },
  FAIL_EXPIRED:  { id: 2, hex: "#e74c3c",   text: "失敗・コード期限切れ" },
  FAIL_AUTH:     { id: 3, hex: "#e74c3c",   text: "失敗・認証エラー" },
  LOCK_OVERTRY:  { id: 4, hex: "#f1c40f",   text: "ロック・認証超過" },
  LOCK_MANUAL:   { id: 5, hex: "#f39c12",   text: "ロック・手動" },
};

// ============================================================================
// PATTERN_DATA_LIST — パターン名 → 日本語ラベル変換
//    ※ normalizeContent() で pattern_name を日本語化するために使用
// ============================================================================
export const PATTERN_DATA_LIST = [
  // ====== D001 ======
  { pattern_id: "P001", department_id: "D001", pattern_name: "title",              pattern_name_norm: "title_norm",              attr_type: "S", pattern_text: "タイトル",      display_idx: 1 },
  { pattern_id: "P002", department_id: "D001", pattern_name: "auto_number",        pattern_name_norm: "auto_number_norm",        attr_type: "N", pattern_text: "オートナンバー", display_idx: 2 },
  { pattern_id: "P003", department_id: "D001", pattern_name: "product_no",         pattern_name_norm: "product_no_norm",         attr_type: "S", pattern_text: "製番",          display_idx: 3 },
  { pattern_id: "P004", department_id: "D001", pattern_name: "document_category",  pattern_name_norm: "",                        attr_type: "N", pattern_text: "図面種類",      display_idx: 4 },
  { pattern_id: "P005", department_id: "D001", pattern_name: "destination",        pattern_name_norm: "destination_norm",        attr_type: "S", pattern_text: "仕向先",        display_idx: 5 },
  { pattern_id: "P006", department_id: "D001", pattern_name: "customer",           pattern_name_norm: "customer_norm",           attr_type: "S", pattern_text: "得意先",        display_idx: 6 },
  { pattern_id: "P007", department_id: "D001", pattern_name: "issue_datetime",     pattern_name_norm: "issue_datetime_norm",     attr_type: "S", pattern_text: "日付",          display_idx: 7 },
  { pattern_id: "P008", department_id: "D001", pattern_name: "assignee",           pattern_name_norm: "assignee_norm",           attr_type: "S", pattern_text: "担当者",        display_idx: 8 },
  { pattern_id: "P009", department_id: "D001", pattern_name: "product_model",      pattern_name_norm: "product_model_norm",      attr_type: "S", pattern_text: "型式",          display_idx: 9 },
  { pattern_id: "P010", department_id: "D001", pattern_name: "document_type",      pattern_name_norm: "",                        attr_type: "N", pattern_text: "図面ﾀｲﾌﾟ",      display_idx: 10 },
  { pattern_id: "P011", department_id: "D001", pattern_name: "variety_name",       pattern_name_norm: "variety_name_norm",       attr_type: "S", pattern_text: "品種名",        display_idx: 11 },
  { pattern_id: "P012", department_id: "D001", pattern_name: "remarks",            pattern_name_norm: "remarks_norm",            attr_type: "S", pattern_text: "備考",          display_idx: 12 },

  // ====== D002 ======
  { pattern_id: "P013", department_id: "D002", pattern_name: "title",              pattern_name_norm: "title_norm",              attr_type: "S", pattern_text: "タイトル",      display_idx: 1 },
  { pattern_id: "P014", department_id: "D002", pattern_name: "auto_number",        pattern_name_norm: "auto_number_norm",        attr_type: "N", pattern_text: "オートナンバー", display_idx: 2 },
  { pattern_id: "P015", department_id: "D002", pattern_name: "product_no",         pattern_name_norm: "product_no_norm",         attr_type: "S", pattern_text: "製番",          display_idx: 3 },
  { pattern_id: "P016", department_id: "D002", pattern_name: "destination",        pattern_name_norm: "destination_norm",        attr_type: "S", pattern_text: "仕向先",        display_idx: 4 },
  { pattern_id: "P017", department_id: "D002", pattern_name: "customer",           pattern_name_norm: "customer_norm",           attr_type: "S", pattern_text: "得意先",        display_idx: 5 },
  { pattern_id: "P018", department_id: "D002", pattern_name: "device_name",        pattern_name_norm: "device_name_norm",        attr_type: "S", pattern_text: "設備名",        display_idx: 6 },
  { pattern_id: "P019", department_id: "D002", pattern_name: "assembly_type",      pattern_name_norm: "assembly_type_norm",      attr_type: "S", pattern_text: "組立種類",      display_idx: 7 },
  { pattern_id: "P020", department_id: "D002", pattern_name: "document_category",  pattern_name_norm: "",                        attr_type: "N", pattern_text: "図面種類",      display_idx: 8 },
  { pattern_id: "P021", department_id: "D002", pattern_name: "issue_datetime",     pattern_name_norm: "issue_datetime_norm",     attr_type: "S", pattern_text: "日付",          display_idx: 9 },
  { pattern_id: "P022", department_id: "D002", pattern_name: "assignee",           pattern_name_norm: "assignee_norm",           attr_type: "S", pattern_text: "担当者",        display_idx: 10 },
  { pattern_id: "P023", department_id: "D002", pattern_name: "remarks",            pattern_name_norm: "remarks_norm",            attr_type: "S", pattern_text: "備考",          display_idx: 11 },

  // ====== D003 ======
  { pattern_id: "P024", department_id: "D003", pattern_name: "title",              pattern_name_norm: "title_norm",              attr_type: "S", pattern_text: "タイトル",      display_idx: 1 },
  { pattern_id: "P025", department_id: "D003", pattern_name: "auto_number",        pattern_name_norm: "auto_number_norm",        attr_type: "N", pattern_text: "オートナンバー", display_idx: 2 },
  { pattern_id: "P026", department_id: "D003", pattern_name: "document_category",  pattern_name_norm: "",                        attr_type: "N", pattern_text: "図面種類",      display_idx: 3 },
  { pattern_id: "P027", department_id: "D003", pattern_name: "category_name",      pattern_name_norm: "category_name_norm",      attr_type: "S", pattern_text: "図面名称",      display_idx: 4 },
  { pattern_id: "P028", department_id: "D003", pattern_name: "customer",           pattern_name_norm: "customer_norm",           attr_type: "S", pattern_text: "得意先",        display_idx: 5 },
  { pattern_id: "P029", department_id: "D003", pattern_name: "product_name",       pattern_name_norm: "product_name_norm",       attr_type: "S", pattern_text: "製品名",        display_idx: 6 },
  { pattern_id: "P030", department_id: "D003", pattern_name: "product_model",      pattern_name_norm: "product_model_norm",      attr_type: "S", pattern_text: "製品形式",      display_idx: 7 },
  { pattern_id: "P031", department_id: "D003", pattern_name: "purpose",            pattern_name_norm: "purpose_norm",            attr_type: "S", pattern_text: "用途",          display_idx: 8 },
  { pattern_id: "P032", department_id: "D003", pattern_name: "issue_datetime",     pattern_name_norm: "issue_datetime_norm",     attr_type: "S", pattern_text: "日付",          display_idx: 9 },
  { pattern_id: "P033", department_id: "D003", pattern_name: "assignee",           pattern_name_norm: "assignee_norm",           attr_type: "S", pattern_text: "担当者",        display_idx: 10 },
  { pattern_id: "P034", department_id: "D003", pattern_name: "document_type",      pattern_name_norm: "",                        attr_type: "N", pattern_text: "図面ﾀｲﾌﾟ",      display_idx: 11 },
  { pattern_id: "P035", department_id: "D003", pattern_name: "original_doc_number",pattern_name_norm: "original_doc_number_norm",attr_type: "S", pattern_text: "元図番",        display_idx: 12 },
  { pattern_id: "P036", department_id: "D003", pattern_name: "remarks",            pattern_name_norm: "remarks_norm",            attr_type: "S", pattern_text: "備考",          display_idx: 13 }
];


// ============================================================================
// 内部オブジェクトの表示順序
// ============================================================================
export const INNER_FIELD_ORDER = ["値", "オプション", "あいまい"];

// ============================================================================
// 除外キー一覧（画面に表示しない項目）
// ============================================================================
export const EXCLUDED_KEYS = [
  "company_id", 
  "department_id", 
  "is_delete",
  "folder_id",
  "user_id",
  "doc_id",
  "c_datetime",
  "u_datetime"
];


// ============================================================================
// DOCUMENT_CATEGORY_LIST — 部門ごとの図面種類一覧
//    document_category（番号）→ document_category_text（日本語名）
// ============================================================================
export const DOCUMENT_CATEGORY_LIST = [
    // ==================== D001 ====================
    { department_id: "D001", document_category:  9, document_category_text: "構成図／ブロック図／系統図",         display_idx:  1 },
    { department_id: "D001", document_category:  1, document_category_text: "仕様書（見積／納入／決定図）",       display_idx:  2 },
    { department_id: "D001", document_category: 10, document_category_text: "ソフト設計書類",                    display_idx:  3 },
    { department_id: "D001", document_category:  7, document_category_text: "フローシート／Ｐ＆ＩＤ",             display_idx:  4 },
    { department_id: "D001", document_category:  6, document_category_text: "外形寸法図",                        display_idx:  5 },
    { department_id: "D001", document_category: 12, document_category_text: "内部配置図／部品配置図",             display_idx:  6 },
    { department_id: "D001", document_category:  4, document_category_text: "端子番号表",                        display_idx:  7 },
    { department_id: "D001", document_category:  2, document_category_text: "結線図",                            display_idx:  8 },
    { department_id: "D001", document_category:  5, document_category_text: "ＰＬＣ結線図",                      display_idx:  9 },
    { department_id: "D001", document_category: 13, document_category_text: "回路図",                            display_idx: 10 },
    { department_id: "D001", document_category: 11, document_category_text: "購入書類（製作仕様書／手配）",        display_idx: 11 },
    { department_id: "D001", document_category: 15, document_category_text: "加工図（板金／小物／銘版／パネル）",   display_idx: 12 },
    { department_id: "D001", document_category: 14, document_category_text: "部品リスト／材料表",                 display_idx: 13 },
    { department_id: "D001", document_category:  3, document_category_text: "取扱説明書",                        display_idx: 14 },
    { department_id: "D001", document_category: 16, document_category_text: "検査要領書／検査成績書",             display_idx: 15 },
    { department_id: "D001", document_category: 17, document_category_text: "出荷構成表",                        display_idx: 16 },
    { department_id: "D001", document_category:  8, document_category_text: "その他",                            display_idx: 17 },

    // ==================== D002 ====================
    { department_id: "D002", document_category:  1, document_category_text: "組立図",                            display_idx:  1 },
    { department_id: "D002", document_category:  2, document_category_text: "製作図",                            display_idx:  2 },
    { department_id: "D002", document_category:  3, document_category_text: "ﾌﾛｰｼｰﾄ",                            display_idx:  3 },
    { department_id: "D002", document_category:  4, document_category_text: "仕様書",                            display_idx:  4 },
    { department_id: "D002", document_category:  5, document_category_text: "完成図書",                          display_idx:  5 },
    { department_id: "D002", document_category:  6, document_category_text: "計画図",                            display_idx:  6 },
    { department_id: "D002", document_category:  8, document_category_text: "図面表",                            display_idx:  7 },
    { department_id: "D002", document_category:  9, document_category_text: "購入品ﾘｽﾄ",                         display_idx:  8 },
    { department_id: "D002", document_category: 10, document_category_text: "検査成績書",                        display_idx:  9 },
    { department_id: "D002", document_category:  7, document_category_text: "その他",                           display_idx: 10 },

    // ==================== D003 ====================
    { department_id: "D003", document_category:  2, document_category_text: "仕様書",                           display_idx:  1 },
    { department_id: "D003", document_category:  3, document_category_text: "取扱説明書",                       display_idx:  2 },
    { department_id: "D003", document_category:  1, document_category_text: "回路図",                           display_idx:  3 },
    { department_id: "D003", document_category:  6, document_category_text: "部品配置図（外形寸法図）",          display_idx:  4 },
    { department_id: "D003", document_category:  9, document_category_text: "座標データ，材料表",                display_idx:  5 },
    { department_id: "D003", document_category:  7, document_category_text: "一覧表",                           display_idx:  6 },
    { department_id: "D003", document_category: 10, document_category_text: "手順書，指示書",                   display_idx:  7 },
    { department_id: "D003", document_category:  8, document_category_text: "加工図，製作図，印刷図",            display_idx:  8 },
    { department_id: "D003", document_category: 11, document_category_text: "銘板図",                          display_idx:  9 },
    { department_id: "D003", document_category: 13, document_category_text: "依頼書",                          display_idx: 10 },
    { department_id: "D003", document_category:  5, document_category_text: "検査成績書",                      display_idx: 11 },
    { department_id: "D003", document_category: 12, document_category_text: "手書き",                          display_idx: 12 }
];


// ============================================================================
// DOCUMENT_TYPE_LIST — 部門ごとの図面タイプ一覧
//    document_type（番号）→ document_type_text（日本語名）
// ============================================================================
export const DOCUMENT_TYPE_LIST = [
    // ---------------- D001 ----------------
    { department_id: "D001", document_type: 1, document_type_text: "WORD",         display_idx: 1 },
    { department_id: "D001", document_type: 2, document_type_text: "EXCEL",        display_idx: 2 },
    { department_id: "D001", document_type: 3, document_type_text: "iCAD",         display_idx: 3 },
    { department_id: "D001", document_type: 4, document_type_text: "電気CAD",      display_idx: 4 },
    { department_id: "D001", document_type: 5, document_type_text: "回路CAD",      display_idx: 5 },
    { department_id: "D001", document_type: 6, document_type_text: "VISIO",        display_idx: 6 },
    { department_id: "D001", document_type: 7, document_type_text: "Power Point",  display_idx: 7 },
    { department_id: "D001", document_type: 8, document_type_text: "その他",       display_idx: 8 },
    { department_id: "D001", document_type: 9, document_type_text: "手書き",       display_idx: 9 },

    // ---------------- D003 ----------------
    { department_id: "D003", document_type: 1, document_type_text: "ﾜｰﾄﾞ",        display_idx: 1 },
    { department_id: "D003", document_type: 2, document_type_text: "ｴｸｾﾙ",        display_idx: 2 },
    { department_id: "D003", document_type: 6, document_type_text: "I-CAD",       display_idx: 3 },
    { department_id: "D003", document_type: 5, document_type_text: "回路CAD",     display_idx: 4 },
    { department_id: "D003", document_type: 7, document_type_text: "電気CAD",     display_idx: 5 },
    { department_id: "D003", document_type: 3, document_type_text: "J-STAR",      display_idx: 6 },
    { department_id: "D003", document_type: 4, document_type_text: "一太郎",      display_idx: 7 },
    { department_id: "D003", document_type: 8, document_type_text: "手書き",      display_idx: 8 }
];

// ============================================================================
//  FOLDER_DATA_LIST — フォルダ定義マスタ
//    folder_id から版数（folder_edition）を取得するための一覧
// ============================================================================
export const FOLDER_DATA_LIST = [
  { folder_id: "F001", folder_edition: "E",  folder_name: "E版図面",       department_id: "D001", display_idx: 1 },
  { folder_id: "F002", folder_edition: "T",  folder_name: "T版図面",       department_id: "D001", display_idx: 2 },
  { folder_id: "F003", folder_edition: "D",  folder_name: "D版図面",       department_id: "D001", display_idx: 3 },
  { folder_id: "F004", folder_edition: "C",  folder_name: "C版図面",       department_id: "D001", display_idx: 4 },
  { folder_id: "F005", folder_edition: "B",  folder_name: "B版図面",       department_id: "D001", display_idx: 5 },

  { folder_id: "F006", folder_edition: "EM", folder_name: "EM版図面",      department_id: "D002", display_idx: 1 },
  { folder_id: "F007", folder_edition: "TM", folder_name: "TM版図面",      department_id: "D002", display_idx: 2 },
  { folder_id: "F008", folder_edition: "DM", folder_name: "DM版図面",      department_id: "D002", display_idx: 3 },
  { folder_id: "F009", folder_edition: "CM", folder_name: "CM版図面",      department_id: "D002", display_idx: 4 },
  { folder_id: "F010", folder_edition: "BM", folder_name: "BM版図面",      department_id: "D002", display_idx: 5 },
  { folder_id: "F011", folder_edition: "ZM", folder_name: "図面表",        department_id: "D002", display_idx: 6 },
  { folder_id: "F012", folder_edition: "KM", folder_name: "購入品リスト",   department_id: "D002", display_idx: 7 },

  { folder_id: "F013", folder_edition: "EK", folder_name: "EK版図面",      department_id: "D003", display_idx: 1 },
  { folder_id: "F014", folder_edition: "TK", folder_name: "TK版図面",      department_id: "D003", display_idx: 2 },
  { folder_id: "F015", folder_edition: "DK", folder_name: "DK版図面",      department_id: "D003", display_idx: 3 },
  { folder_id: "F016", folder_edition: "CK", folder_name: "CK版図面",      department_id: "D003", display_idx: 4 },
];


// ============================================================================
// KEY_REPLACE_MAP — キー名置換マップ
//    content 内の各フィールドを日本語に変換するための定義一覧
//    ・label      : 画面表示用の日本語ラベル
//    ・valueMap   : 数値 → 日本語表記の変換マップ
//    ・convert    : 部門IDなどを参照し、日本語へ動的変換する関数
//    ・nested     : value / option / ambiguous などの入れ子オブジェクトを処理
// ============================================================================

export const KEY_REPLACE_MAP = {

  // ---------------------------------------------------------------------------
  // 通常フィールド（キー名 → 日本語ラベル）
  // ---------------------------------------------------------------------------
  data_limit:             { label: "検索上限数" },
  company_id:             { label: "会社コード" },
  department_id:          { label: "部門コード" },
  folder_id:              { label: "フォルダID" },
  issue_datetime_start:   { label: "開始日" },
  issue_datetime_end:     { label: "終了日" },

  // ---------------------------------------------------------------------------
  // AND / OR 検索モード
  // ---------------------------------------------------------------------------
  and_flag: {
    label: "検索方法",
    valueMap: {
      1: "すべての条件",
      0: "いずれかの条件"
    }
  },  

  // ---------------------------------------------------------------------------
  // 図面種類（document_category）— 部門IDに応じて動的に変換
  // ---------------------------------------------------------------------------
  document_category: {
    label: "図面種類",
    convert: (content, value) =>
      getDocumentCategoryText(content.department_id, value)
  },

  // ---------------------------------------------------------------------------
  // 図面タイプ（document_type）— 部門IDに応じて動的に変換
  // ---------------------------------------------------------------------------
  document_type: {
    label: "図面ﾀｲﾌﾟ",
    convert: (content, value) =>
      getDocumentTypeText(content.department_id, value)
  },  

  // ---------------------------------------------------------------------------
  // ネスト内部キー（value / option / ambiguous）
  // ---------------------------------------------------------------------------
  value: {
    label: "値",
    nested: true
  },

  option: {
    label: "オプション",
    nested: true,
    valueMap: {
      0: "を含む",
      1: "で始まる",
      2: "と等しい",
      3: "で終わる"
    }
  },

  ambiguous: {
    label: "あいまい",
    nested: true,
    valueMap: {
      0: "無効",
      1: "有効"
    }
  }
};